import { createSlice } from "@reduxjs/toolkit";

import { logoutUser } from "../actions/account";
import { addActivity, createLogsFromGoals, createLogsFromLocations, addWavesFromGoalsList, addWavesFromLocations, deleteActivityByActivityId, editActivityById, getActivitiesByInstitutionId, getActivitiesByWaveId, getActivityTemplateByInstitutionId, getGhostLogs } from "../actions/activity";

const initialState = {
  error: false,
  isLoadingGetActivityTemplatesByInstitutionId:false,
  activityTemplatesList:[],
  isLoadingGetActivitiesByInstitutionId:false,
  activitiesList:[],
  isLoadingAddActivity:false,
  isLoadingGetActivitiesByWaveId:false,
  activitiesByWaveId:{},
  isLoadingActivitiesForWave: {} ,
  isLoadingDeleteActivityByActivityId:false,
  isLoadingGetGhostLogs:false,
  listOfGhostLogs:[],
  isLoadingEditActivityById:false,
  isLoadingAddWavesFromGoalsList:false,
  isLoadingAddActivitiesFromGoalsList:false,
  isLoadingAddWavesFromLocations:false,
  isLoadingAddLogsFromLocationsList:false
};

const activitySlice = createSlice({
  name: "activity",
  initialState,
  reducers: {
    "account/logoutUser": (state) => initialState,
  },
  extraReducers: {
    
   [getActivityTemplateByInstitutionId.fulfilled]:(state,action)=>{
    state.isLoadingAddLocationGroup = false;
    state.activityTemplatesList=action?.payload?.activity_template;
    state.error = false;
   },
   [getActivityTemplateByInstitutionId.rejected]:(state,action)=>{
    state.isLoadingAddLocationGroup = false;
    state.error = true;
   },
   [getActivityTemplateByInstitutionId.pending]:(state,action)=>{
    state.isLoadingAddLocationGroup = true;
    state.error = false;
   },

   [getActivitiesByInstitutionId.fulfilled]:(state,action)=>{
    state.isLoadingGetActivitiesByInstitutionId = false;
    state.activitiesList=action?.payload?.activity;
    state.error = false;
   },
   [getActivitiesByInstitutionId.rejected]:(state,action)=>{
    state.isLoadingGetActivitiesByInstitutionId = false;
    state.error = true;
   },
   [getActivitiesByInstitutionId.pending]:(state,action)=>{
    state.isLoadingGetActivitiesByInstitutionId = true;
    state.error = false;
   },
   [getActivitiesByWaveId.pending]: (state, action) => {
    const waveId = action.meta.arg?.moduleId;
    if (waveId) {
      state.isLoadingActivitiesForWave = {
        ...state.isLoadingActivitiesForWave,
        [waveId]: true,
      };
    }
    state.error = false;
  },
  
  [getActivitiesByWaveId.fulfilled]: (state, action) => {
    const { activity } = action.payload;
    const waveId = activity?.[0]?.moduleId || action.meta.arg?.moduleId;
  
    if (waveId) {
      state.activitiesByWaveId = {
        ...state.activitiesByWaveId,
        [waveId]: Array.isArray(activity) ? activity : [],
      };
  
      state.isLoadingActivitiesForWave = {
        ...state.isLoadingActivitiesForWave,
        [waveId]: false,
      };
    }
  
    state.error = false;
  },
  
  [getActivitiesByWaveId.rejected]: (state, action) => {
    const waveId = action.meta.arg?.moduleId;
    if (waveId) {
      state.isLoadingActivitiesForWave = {
        ...state.isLoadingActivitiesForWave,
        [waveId]: false,
      };
    }
    state.error = true;
  },
  
   [addActivity.rejected]:(state,action)=>{
    state.isLoadingAddActivity = false;
    state.error = true;
   },
   [addActivity.pending]:(state,action)=>{
    state.isLoadingAddActivity = true;
    state.error = false;
   },
   [addActivity.fulfilled]:(state)=>{
    state.isLoadingAddActivity=false;
    state.error=false;
   },
   [addWavesFromGoalsList.rejected]:(state,action)=>{
    state.isLoadingAddWavesFromGoalsList = false;
    state.error = true;
   },
   [addWavesFromGoalsList.pending]:(state,action)=>{
    state.isLoadingAddWavesFromGoalsList = true;
    state.error = false;
   },
   [addWavesFromGoalsList.fulfilled]:(state)=>{
    state.isLoadingAddWavesFromGoalsList=false;
    state.error=false;
   },
   [addWavesFromLocations.rejected]:(state,action)=>{
    state.isLoadingAddWavesFromLocations = false;
    state.error = true;
   },
   [addWavesFromLocations.pending]:(state,action)=>{
    state.isLoadingAddWavesFromLocations = true;
    state.error = false;
   },
   [addWavesFromLocations.fulfilled]:(state)=>{
    state.isLoadingAddWavesFromLocations=false;
    state.error=false;
   },
   [createLogsFromGoals.rejected]:(state,action)=>{
    state.isLoadingAddActivitiesFromGoalsList = false;
    state.error = true;
   },
   [createLogsFromGoals.pending]:(state,action)=>{
    state.isLoadingAddActivitiesFromGoalsList = true;
    state.error = false;
   },
   [createLogsFromGoals.fulfilled]:(state)=>{
    state.isLoadingAddActivitiesFromGoalsList=false;
    state.error=false;
   },
   [createLogsFromLocations.rejected]:(state)=>{
    state.isLoadingAddLogsFromLocationsList = false;
    state.error = true;
   },
   [createLogsFromLocations.pending]:(state)=>{
    state.isLoadingAddLogsFromLocationsList = true;
    state.error = false;
   },
   [createLogsFromLocations.fulfilled]:(state)=>{
    state.isLoadingAddLogsFromLocationsList=false;
    state.error=false;
   },
   
   [deleteActivityByActivityId.rejected]:(state,action)=>{
    state.isLoadingDeleteActivityByActivityId = false;
    state.error = true;
   },
   [deleteActivityByActivityId.pending]:(state,action)=>{
    state.isLoadingDeleteActivityByActivityId = true;
    state.error = false;
   },
   [deleteActivityByActivityId.fulfilled]:(state,action)=>{
    state.isLoadingDeleteActivityByActivityId = false;
    state.error = false;
   },
   [editActivityById.rejected]:(state,action)=>{
    state.isLoadingEditActivityById = false;
    state.error = true;
   },
   [editActivityById.pending]:(state,action)=>{
    state.isLoadingEditActivityById = true;
    state.error = false;
   },
   [editActivityById.fulfilled]:(state,action)=>{
    state.isLoadingEditActivityById = false;
    state.error = false;
   },
    [logoutUser.fulfilled]: (state) => {
      return initialState;
    },
    [logoutUser.rejected]: (state) => {
      return initialState;
    },
  },
});

export const getError = (state) => state?.activity?.error;
export const getIsLoadingGetActivityTemplatesByInstitutionId=(state)=>state?.activity?.isLoadingGetActivityTemplatesByInstitutionId;
export const getActivityTemplatesList=(state)=>state?.activity?.activityTemplatesList;
export const getActivitysByInstitutionId=(state)=>state?.activity?.activitiesList;
export const getActivityList=(state)=>state?.activity?.activitiesList;
export const getActivityByWaveId=(state)=>state?.activity?.activitiesByWaveId
export const getIsLoadingActivitiesForWave=(state)=>state?.activity?.isLoadingActivitiesForWave
export const getIsLoadingDeleteActivityByActivityId=(state)=>state?.activity?.isLoadingDeleteActivityByActivityId  
export const getIsLoadingEditActivityById=(state)=>state?.activity?.isLoadingEditActivityById
export const getIsLoadingAddActivity=(state)=>state?.activity?.isLoadingAddActivity
export const getIsLoadingAddWavesFromGoalsList=(state)=>state?.activity?.isLoadingAddWavesFromGoalsList
export const getIsLoadingAddActivitiesFromGoalsList=(state)=>state?.activity?.isLoadingAddActivitiesFromGoalsList
export const getIsLoadingAddWavesFromLocations=(state)=>state?.activity?.isLoadingAddWavesFromLocations
export const getIsLoadingAddLogsFromLocationsList=(state)=>state?.activity?.isLoadingAddLogsFromLocationsList
export const getIsLoadingGetActivitiyTemplate=(state)=>state?.activity?.isLoadingGetActivityTemplatesByInstitutionId

// export const 
export default activitySlice;
